import { useCallback, useEffect } from "react";

// initialise sound
const audioInitialisedLocalStorageKey = "a-init";

// default init off
sessionStorage.removeItem(audioInitialisedLocalStorageKey);

const setIsAudioInitialised = (initialised: boolean) => {
    if (initialised) {
        sessionStorage.setItem(audioInitialisedLocalStorageKey, "true");
    } else {
        sessionStorage.removeItem(audioInitialisedLocalStorageKey);
    }
};

export const getIsAudioInitialised = () => !!sessionStorage.getItem(audioInitialisedLocalStorageKey);

export const useInitialiseAudio = () => {
    // track sound first click for safari
    const unlockAudio = useCallback(() => {
        // unbind listeners
        document.body.removeEventListener("click", unlockAudio);
        document.body.removeEventListener("touchstart", unlockAudio);

        setIsAudioInitialised(true);
    }, []);

    useEffect(() => {
        // listen for initial interaction to enable sound
        document.body.addEventListener("click", unlockAudio);
        document.body.addEventListener("touchstart", unlockAudio);
    }, [unlockAudio]);
};
